import styled from 'astroturf/react'
const colorTextStandard = 'var(--colorTextStandard, var(--coreColorNeutral900))'
const colorStrokeStandard = 'var(--colorStrokeStandard, var(--coreColorNeutral400))'
const colorBackgroundTertiary = 'var(--colorBackgroundTertiary, var(--coreColorNeutral300))'
const colorSurfaceStandard = 'var(--colorSurfaceStandard, var(--coreColorNeutral0))'
const fontSizeMedium = 'var(--fontSizeMedium, 0.875rem)'
const fontWeightStandard = 'var(--fontWeightStandard, 400)'
const lineHeightBodyMedium = 'var(--lineHeightBodyMedium, 1.4)'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import { OnetrustSettingsButton } from '@calendly/onetrust/redux'
import _Bricks from "styles-Bricks.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_event_type/styles.js?styleId=Bricks";
import _Arrow from "styles-Arrow.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_event_type/styles.js?styleId=Arrow";
import _TitleContainer from "styles-TitleContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_event_type/styles.js?styleId=TitleContainer";
import _Marker from "styles-Marker.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_event_type/styles.js?styleId=Marker";
import _Header from "styles-Header.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_event_type/styles.js?styleId=Header";
import _Link from "styles-Link.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_event_type/styles.js?styleId=Link";
import _Description from "styles-Description.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_event_type/styles.js?styleId=Description";
import _MetaRow from "styles-MetaRow.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_event_type/styles.js?styleId=MetaRow";
import _MetaItem from "styles-MetaItem.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_event_type/styles.js?styleId=MetaItem";
import _CookieSettingsButton from "styles-CookieSettingsButton.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_event_type/styles.js?styleId=CookieSettingsButton";


export const Bricks = /*#__PURE__*/styled('div', null, {
  displayName: "Bricks",
  styles: _Bricks
})

export const Arrow = /*#__PURE__*/styled('div', null, {
  displayName: "Arrow",
  styles: _Arrow
})

export const TitleContainer = /*#__PURE__*/styled('div', null, {
  displayName: "TitleContainer",
  styles: _TitleContainer
})

export const Marker = /*#__PURE__*/styled('div', null, {
  displayName: "Marker",
  styles: _Marker,
  attrs: ({
    color,
    ...props
  }) => ({
    ...props,
    style: {
      backgroundColor: color
    }
  })
})

export const Header = /*#__PURE__*/styled('div', null, {
  displayName: "Header",
  styles: _Header
})

export const Link = /*#__PURE__*/styled('a', null, {
  displayName: "Link",
  styles: _Link,
  attrs: props => ({
    ...props,
    isTabletUp: useDeviceType('isTabletUp')
  })
})

export const Description = /*#__PURE__*/styled('p', null, {
  displayName: "Description",
  styles: _Description
})

export const MetaRow = /*#__PURE__*/styled('div', null, {
  displayName: "MetaRow",
  styles: _MetaRow
})

export const MetaItem = /*#__PURE__*/styled('div', null, {
  displayName: "MetaItem",
  styles: _MetaItem
})

export const CookieSettingsButton = /*#__PURE__*/styled(OnetrustSettingsButton, null, {
  displayName: "CookieSettingsButton",
  styles: _CookieSettingsButton,
  attrs: props => ({
    ...props,
    isTabletDown: useDeviceType('isTabletDown'),
    isDesktopUp: useDeviceType('isDesktopUp')
  })
})
